import { fechFromBPartsApi } from '../utils';

export const fastRegisterSave = async (
  variables: TSaveResquest
): Promise<void> => {
  const response = await fechFromBPartsApi(
    `/${variables.locale}/shop/accounts/fast-registration`,
    {
      method: 'post',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', variables.csrftoken],
        ['b-origin', process.env.NEXT_PUBLIC_TENANT || '1'],
      ]),
      credentials: 'include',
      body: JSON.stringify(variables.formData),
    }
  );

  if (response.status === 204) {
    return;
  }
  if (response.status === 403) {
    throw { securityError: 'Security Error' };
  }
  let json;
  try {
    json = await response.json();
  } catch (error) {
    throw { serverError: error };
  }

  if (!response.ok) {
    Object.keys(json).map(function (key, i) {
      if (
        key == 'shipping_destination' ||
        key == 'currency' ||
        key == 'language'
      ) {
        throw { serverError: 'Invalid session info' };
      }
    });
    throw json;
  }
  return json;
};
